/**
 * Shopify Ajaxify Shop. 
 * 
 * @uses Modified Shopify jQuery API (link to it)
 *
 */

// Binding events every time when open modal window with cart
var  bindEventsInCart = function(){
  
  var modalForm = $(".modal-popup form");
    $additionCheckoutBlock = modalForm.find("#additional-checkout-block");
    $additionCheckoutBlock.load('/cart #addCheckoutBtn', function() {
      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    });

  $(".cart_menu").on("click",".remove_item_button", function(e){
    e.preventDefault();

    var el = $(this),
        id = el.data('id') || null;

    Shopify.removeItem(id, function(cart){
      Shopify.updateQuickCart(cart);
    });
  });

  /////////////////////////////////////
  // Qty for cart modal
  /////////////////////////////////////
  jQuery(".cart_menu").on("click", ".minus_btn", function () {
    Shopify.scStepQuantity(this, -1);
  })


  jQuery(".cart_menu").on("click",".plus_btn", function () {
    Shopify.scStepQuantity(this, +1);
  })

  /// Save cart note///
  $(".cart_menu").on("focusout","textarea", function(){
    var note = $(this).val(),
        textareas = $(".div.cart_menu").find("textarea").add($(".cart_tbl textarea"));

    Shopify.updateCartNote(note, function(){
      $(textareas).each(function () {
        $(this).val(note);
        $(this).text(note);
      });
    });
  });

  /// Closing modal///
  $(".cart_menu").on("click",".info_btn", function(){
    var magnificPopup = $.magnificPopup.instance;
    if(typeof magnificPopup !== 'undefined'){
      magnificPopup.close();
    }
  });
  $(".cart_menu").on("click",".btn_close", function(){
    var magnificPopup = $.magnificPopup.instance;
    if(typeof magnificPopup !== 'undefined'){
      magnificPopup.close();
    }
  });
  
  //Bold: POv2
  $('[name=checkout].bold_hidden').removeAttr('style').removeClass('bold_hidden');      
  $('[name=checkout].bold_clone').remove();
  window.BOLD.options.app.checkoutFix();
  //Bold: POv2

  
}

jQuery(document).ready(function() { 
  //Begin Wrapper

  var jQ = jQuery;

  /**
 * Collection of Selectors for various pieces on the page we need to update 
 *
 * I've tried to keep these as general and flexible as possible, but 
 * if you are doing your own markup, you may find you need to change some of these.
 *
 */
  var selectors = {
    // Any elements(s) with this selector will have the total item count put there on add to cart.
    TOTAL_ITEMS: '.count', 
    TOTAL_PRICE: '.cart-total-price',
    SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',
    FORM_ADD_TO_CART: 'form[action*="/cart/add"]',
    FORM_UPDATE_CART: 'form[name=cartform]',
    //The actual Update Button
    FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
    //All the buttons on the form
    FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',
    LINE_ITEM_ROW: '.cart-line-item',
    LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
    LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',
    LINE_ITEM_REMOVE: '.remove a',
    EMPTY_CART_MESSAGE: '#empty',
    QUICK_CART_MENU: 'div.cart_menu',
    CART_PAGE_MENU: '.cart_tbl'
  };

  /**
 * Collection of text strings. This is where you would change for a diff language, for example. 
 *
 */
  var text = {
    ITEM: 'Item', 
    ITEMS: 'Items'
  };

  //Convenience method to format money. 
  //Can just transform the amount here if needed
  window.formatMoney = function(price) {
    return Shopify.formatMoney(price, app.data.money_format);
  };

  //We only want to interrupt the UPDATE, not the CHECKOUT process
  jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function(e) {
    e.preventDefault();
    jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
    Shopify.updateCartFromForm(e.target.form);
  });

  //Delegate the Remove Link functionality on the cart page.
  jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function(e) {
    e.preventDefault();
    //Get the variant ID from the URL
    var vid = this.href.split('/').pop().split('?').shift();
    Shopify.removeItem(vid);
    jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
  });

  /**
 * Shopify.showModal
 * 
 * @param string contents
 * @param integer hideDelay
 */
  Shopify.modalTimer = false;
  Shopify.showModal = function(contents,hideDelay) {
    $("html").css("overflow-y","hidden");

    //Ensure the plugin is loaded
    if(typeof $().magnificPopup !== 'function'){ return }

    //Check the function vars have been sent
    if(typeof contents === 'undefined'){ return }
    //if(typeof hideDelay === 'undefined'){ var hideDelay = 7000 /* default */ }

    //Open the modal
    $.magnificPopup.open({
      items: {
        src: '<div class="mfp-with-anim modal-popup">'+contents+'</div>',
        type: 'inline'
      },
      mainClass: 'mfp-move-from-top',
      removalDelay: 1000,
      callbacks: {
        close: function() {
          $("html").css("overflow-y","auto");
        }
      }
    });

    bindEventsInCart();
  };

  
  Shopify.addImageSize = function(src,size){
    if(typeof size === 'undefined'){ return src; }
    if(src === null){ return "\/\/www.soulceramics.com\/cdn\/shop\/t\/41\/assets\/no-image.gif?v=70791486150938284421781164736" }
    size = '_' + size + '.';
    return src.replace(/.([^.]*)$/,size+'$1');
  };

  /**
   * Shopify.scClydeCartGuard
   *
   * Clyde does not tidy up after itself: removing a product leaves behind the plan
   * that was bought for it, so the shopper can check out paying for cover on
   * something they are not buying. Any plan whose Reference variant is no longer in
   * the cart is dropped here.
   *
   * Plan lines are the ones with product_type "clyde_contract"; the variant they
   * cover is in their "Reference" property. Plans are bought on the product page -
   * the cart-page offer is switched off at Clyde, because it attached about half of
   * them to the wrong item - but they still land in the cart as line items, so they
   * still need watching.
   *
   * @param object  cart       - the cart, already through Bold's cartDoctor
   * @param boolean onCartPage - unused since the reload went: the page is redrawn in
   *                             place either way. Kept so the two call sites and the
   *                             next reader do not have to change to learn that.
   */
  Shopify.scClydeCartGuard = function(cart, onCartPage){
    if(!cart || !cart.items || Shopify.scClydeClearing){ return; }

    var plans = [], variants = {}, i;
    for(i = 0; i < cart.items.length; i++){
      if(cart.items[i].product_type === 'clyde_contract'){ plans.push(cart.items[i]); }
      else { variants[String(cart.items[i].variant_id)] = true; }
    }

    var orphans = [];
    for(i = 0; i < plans.length; i++){
      var covers = plans[i].properties && plans[i].properties.Reference;
      if(covers && !variants[String(covers)]){ orphans.push(plans[i]); }
    }
    if(!orphans.length){ return; }

    /* Three goes per session, then leave it alone: every pass ends in a reload, and a
       cart that refuses to change must not be able to loop the page. */
    var attempts = 0;
    try { attempts = parseInt(sessionStorage.getItem('scClydeFixes') || '0', 10) || 0; } catch(e){}
    if(attempts >= 3){ return; }
    Shopify.scClydeClearing = true;
    try { sessionStorage.setItem('scClydeFixes', String(attempts + 1)); } catch(e){}

    /* All of them in one write. This used to be one /cart/change.js per orphan, run
       one after another, and a cart write on this shop costs 550-840ms - so clearing
       three plans was over two seconds before the page even started catching up.
       /cart/update.js takes every line in a single call for the same one write. */
    var updates = {};
    for(i = 0; i < orphans.length; i++){ updates['updates[' + orphans[i].key + ']'] = 0; }

    /* The write removes the lines but jQuery reports the call as failed often enough
       that its callback cannot be trusted. Ask the cart instead. */
    jQuery.post('/cart/update.js', updates).always(function(){
      jQuery.getJSON('/cart.js', function(fresh){
        var left = {}, a, b;
        for(a = 0; a < fresh.items.length; a++){ left[fresh.items[a].key] = true; }
        for(b = 0; b < orphans.length; b++){
          /* Still there - leave the counter spent so a cart that refuses to change
             cannot be asked forever, and let the next cart update try again. */
          if(left[orphans[b].key]){ Shopify.scClydeClearing = false; return; }
        }
        /* Cleared, so this session gets its three goes back. */
        try { sessionStorage.removeItem('scClydeFixes'); } catch(e){}
        /* Redraw rather than reload. window.location.reload() here threw away the
           whole page - and with it Clyde's widgets and Bold's buttons, which is what
           scSyncCartRows exists to preserve - to show a cart we were already holding.
           updateQuickCart reconciles the rows in place; the re-entrant guard call it
           makes returns at the top while scClydeClearing is still set, which is why
           that flag is only dropped afterwards. */
        Shopify.updateQuickCart(fresh);
        Shopify.scClydeClearing = false;
      }).fail(function(){ Shopify.scClydeClearing = false; });
    });
  };

  /**
   * Shopify.scOptimisticRemove
   *
   * Removing a cart line waits on POST /cart/change.js, and that call costs 550-840ms
   * no matter what the theme does. Measured 2026-10-17: Shopify's own Server-Timing on
   * the response reports processing;dur=460-602 of which fetch;dur=428-574 - about 95%
   * of the server's time is one outbound call inside Shopify's cart-write path, with
   * db;dur=2-3. The same ~450ms fetch shows on unrelated Shopify stores, and a plain
   * curl - one request at a time, no browser, no other connections - still takes
   * 626-780ms. So it is not our JS, not the mini-cart rebuild and not the browser
   * running out of sockets. It is not ours to make faster.
   *
   * What is ours is the waiting. The row comes out on click and the figures are
   * corrected from cents we already have on the page, so the removal reads as instant;
   * the response then reconciles the real cart over the top. If the call fails the row
   * goes back exactly where it was, spacer and all, and the figures with it.
   *
   * @param key - the line key from the remove control's data-id
   * @return an object with restore() and commit(), or null when the row could not be
   *         found - in which case the caller should just do the old thing and wait.
   */
  /**
   * Shopify.scVisibleItemCount
   *
   * What the shopper can actually see, which is not cart.item_count.
   *
   * Bold Options bills a configured product as several line items: one parent line
   * carrying _boldBuilderId AND _boldVariantIds, plus one child line per chosen option
   * carrying _boldBuilderId ALONE. Confirmed against real orders - #10140 is a single
   * kiln the shopper sees as one row and Shopify counts as nine line items.
   *
   * So the header badge read "6" for one Jen-Ken kiln, on every page, and stayed there.
   * Bold's cartDoctor sometimes collapses the cart before onCartUpdate reads it and
   * sometimes does not, which is why the number looked intermittent. Counting the
   * visible lines ourselves is right either way: once Bold has collapsed them the child
   * lines are already gone and this filter simply matches nothing.
   *
   * Same test as templates/cart.liquid's visible_item_count and
   * snippets/bold-options-hybrid-cart-item.liquid, so all three agree. Loose == so a
   * missing property counts the same as an explicit null, which is what Liquid's
   * "== null" means.
   *
   * @param cart - a cart object, fixed or unfixed
   * @return the number of units behind the rows the shopper can see
   */
  Shopify.scVisibleItemCount = function(cart){
    if(!cart || !cart.items){ return 0; }
    var n = 0;
    for(var i = 0; i < cart.items.length; i++){
      var p = cart.items[i].properties || {};
      if(p._boldBuilderId && p._boldVariantIds == null){ continue; }
      n += cart.items[i].quantity;
    }
    return n;
  };

  /**
   * Shopify.scEmptyCartHtml
   *
   * The cart page's empty state, in one place because it is now rendered from two:
   * optimistically when the last row goes, and by updateQuickCart when the response
   * confirms it.
   */
  Shopify.scEmptyCartHtml = function(){
    return '<div class="empty-cart-message"><p>Your cart is currently empty.</p>' +
           '<p><a href="/collections/all" class="btn_c">Continue Shopping</a></p></div>';
  };

  Shopify.scOptimisticRemove = function(key){
    var container = document.querySelector('.cart_tbl .con_row');
    if(!container || !key){ return null; }

    /* The row is the <ul> holding the quantity box for this line. */
    var row = null, boxes = container.querySelectorAll('.txtbox'), i;
    for(i = 0; i < boxes.length; i++){
      if(boxes[i].getAttribute('data-id') === key){
        row = boxes[i];
        while(row && row.parentNode !== container){ row = row.parentNode; }
        break;
      }
    }
    if(!row || row.tagName !== 'UL'){ return null; }

    /* A row carrying a Clyde band owns the .sc-cart-clyde spacer that follows it
       (see conv-cust-js.js) - the pair moves together or not at all. */
    var spacer = row.nextElementSibling;
    if(!spacer || String(spacer.className).indexOf('sc-cart-clyde') < 0){ spacer = null; }

    var anchor = (spacer || row).nextSibling;       /* where to put it back */

    /* Subtotal in cents, kept on the element by Liquid and by updateQuickCart so it
       survives a re-render. Without it the figures are left to the response.

       Scoped to .cart_tbl deliberately: snippets/menu-cart.liquid renders a second
       ".total_row .total-price" for the header drawer, and being in the header it comes
       first in the document - a bare querySelector returns that one, which is not the
       figure on this page. updateQuickCart writes both, so this does too; writing the
       drawer's is also what wakes the sticky bar's MutationObserver in conv-cust-js.js,
       which is watching the first one it found. */
    var totalEl = document.querySelector('.cart_tbl span.total-price');
    var drawerTotals = document.querySelectorAll('div.cart_menu span.total-price');
    var lineCents = parseInt(row.getAttribute('data-line-price'), 10);
    var totalCents = totalEl ? parseInt(totalEl.getAttribute('data-cart-total'), 10) : NaN;
    var canDoMoney = totalEl && !isNaN(lineCents) && !isNaN(totalCents) &&
                     window.Shopify && typeof Shopify.formatMoney === 'function' &&
                     window.app && app.data && app.data.money_format;
    var oldTotalHtml = totalEl ? totalEl.innerHTML : null;
    var oldDrawerHtml = [].map.call(drawerTotals, function(el){ return el.innerHTML; });

    var headerEls = jQ(selectors.TOTAL_ITEMS);
    var oldHeader = headerEls.length ? headerEls.first().text() : null;
    var oldHeaderHidden = headerEls.length ? headerEls.first().hasClass('hidden') : false;

    /* Taking the last row out empties the cart, and the empty state is rendered here
       rather than left to the response. Two reasons. It is what the shopper asked for,
       so it should not arrive 700ms late. And Bold navigates the whole page to /cart
       about 1.6s after the last Bold-configured row goes - traced to
       options.shopapps.site/js/options.js, which is not ours to stop - so the page is
       going to be rebuilt anyway; rendering the right thing first means the reload
       lands on the view that is already showing instead of correcting it. */
    var cartTbl = document.querySelector('.cart_tbl');
    var oldCartTblHtml = null;

    /* Removing a Bold parent leaves its hidden option lines behind in the cart, and
       Bold is the only thing that clears them - it reloads the page to /cart to do it.
       After one measured run where the optimistic empty state went up and those five
       child lines were still on the server 24s later, the empty state is NOT rendered
       early for a Bold parent: that path keeps exactly the behaviour it had, so Bold's
       tidying is never raced. The row still leaves on the click, and the figures are
       still corrected - only the empty state waits. A shopper seeing an empty cart
       while the server still holds five option lines they would be charged for is far
       worse than the redraw arriving 700ms late.

       NOT verified either way: whether rendering it early actually suppresses Bold's
       cleanup, or whether Bold's cleanup is simply unreliable on its own. One
       observation each way, in an environment where Bold's cartDoctor itself behaved
       inconsistently. This is the cautious reading of that, not a proven mechanism. */
    var isBoldParent = row.getAttribute('data-bold-parent') === '1';

    /* Captured BEFORE anything is touched, and only when this is the last row: it has
       to be able to put back the row AND the subtotal that went with it, and a copy
       taken after the removal has neither. */
    var ulCount = 0, sibs = container.children, sc;
    for(sc = 0; sc < sibs.length; sc++){ if(sibs[sc].tagName === 'UL'){ ulCount++; } }
    if(ulCount === 1 && cartTbl && !isBoldParent){ oldCartTblHtml = cartTbl.innerHTML; }

    /* Take it out. */
    if(spacer){ spacer.parentNode.removeChild(spacer); }
    row.parentNode.removeChild(row);

    /* Units still on screen. Counted from the rows rather than taken off the badge:
       the badge may still hold Bold's inflated cart.item_count from the server render,
       and subtracting from a wrong number keeps it wrong. Bold's hidden option lines
       carry .bold_qty, not .txtbox, so .txtbox is exactly the visible rows. */
    var unitsLeft = 0, boxesLeft = container.querySelectorAll('.txtbox'), u;
    for(u = 0; u < boxesLeft.length; u++){ unitsLeft += parseInt(boxesLeft[u].value, 10) || 0; }
    var rowsLeft = 0, kids = container.children, k;
    for(k = 0; k < kids.length; k++){ if(kids[k].tagName === 'UL'){ rowsLeft++; } }

    if(canDoMoney){
      var next = Math.max(0, totalCents - lineCents);
      var money = Shopify.formatMoney(next, app.data.money_format);
      totalEl.setAttribute('data-cart-total', String(next));
      totalEl.innerHTML = money;
      /* The drawer's copy, which is the one the sticky bar's observer is watching; it
         also recounts "(n items)" from the rows left on screen. */
      for(var d = 0; d < drawerTotals.length; d++){ drawerTotals[d].innerHTML = money; }
    }
    if(headerEls.length){
      if(unitsLeft > 0){ headerEls.text(String(unitsLeft)).removeClass('hidden'); }
      else { headerEls.text('').addClass('hidden'); }
    }

    /* Nothing left: show the empty state now. */
    if(!rowsLeft && cartTbl && oldCartTblHtml !== null){
      cartTbl.innerHTML = Shopify.scEmptyCartHtml();
      if(canDoMoney){
        var zero = Shopify.formatMoney(0, app.data.money_format);
        for(var e = 0; e < drawerTotals.length; e++){ drawerTotals[e].innerHTML = zero; }
      }
    }

    return {
      /* Put it all back - the call did not happen. */
      restore: function(){
        /* The empty state replaced the table, so that goes back before the row does.
           Anything with an iframe in it - a Clyde band, the wallet buttons - reloads
           on the way back, which is the price of having shown the empty state early;
           it only happens when a removal actually failed. */
        if(oldCartTblHtml !== null && cartTbl){
          /* The whole table as it stood before the click - row, subtotal and all.
             Anything with an iframe in it reloads on the way back, which is the price
             of having shown the empty state early; it only happens when a removal
             actually failed. */
          cartTbl.innerHTML = oldCartTblHtml;
          oldCartTblHtml = null;
        }else{
          container.insertBefore(row, anchor && anchor.parentNode === container ? anchor : null);
          if(spacer){ container.insertBefore(spacer, row.nextSibling); }
          if(canDoMoney){
            totalEl.setAttribute('data-cart-total', String(totalCents));
            totalEl.innerHTML = oldTotalHtml;
          }
        }
        for(var d2 = 0; d2 < drawerTotals.length; d2++){ drawerTotals[d2].innerHTML = oldDrawerHtml[d2]; }
        if(headerEls.length && oldHeader !== null){
          if(oldHeaderHidden){ headerEls.text(oldHeader).addClass('hidden'); }
          else { headerEls.text(oldHeader).removeClass('hidden'); }
        }
      },
      commit: function(){ row = spacer = null; }
    };
  };

  /**
   * Shopify.scRemoveLine
   *
   * The cart page's one way out of a line: hide it now, ask Shopify, reconcile.
   *
   * Removals can overlap - 600ms is long enough to click a second row - and each
   * response carries a whole-cart snapshot that may predate the other call. Letting
   * every snapshot redraw would put an already-removed row back. So only the last call
   * still in flight reconciles, and once two have overlapped it reconciles from a fresh
   * /cart.js (a cached read, ~40ms of server time) rather than from a snapshot that
   * cannot be trusted to be the newest.
   *
   * @param key - the line key
   */
  Shopify.scRemoveLine = function(key){
    var pending = Shopify.scOptimisticRemove(key);

    Shopify.scRemovalsInFlight = (Shopify.scRemovalsInFlight || 0) + 1;
    if(Shopify.scRemovalsInFlight > 1){ Shopify.scRemovalsOverlapped = true; }

    var settle = function(cart){
      Shopify.scRemovalsInFlight = Math.max(0, (Shopify.scRemovalsInFlight || 1) - 1);
      if(Shopify.scRemovalsInFlight > 0){ return; }   /* a later call will redraw */
      if(Shopify.scRemovalsOverlapped){
        Shopify.scRemovalsOverlapped = false;
        jQuery.getJSON('/cart.js', function(fresh){ Shopify.updateQuickCart(fresh); })
              .fail(function(){ if(cart){ Shopify.updateQuickCart(cart); } });
        return;
      }
      if(cart){ Shopify.updateQuickCart(cart); }
    };

    Shopify.removeItem(key, function(cart){
      if(pending){ pending.commit(); }
      settle(cart);
    }, function(xhr, status){
      if(pending){ pending.restore(); }
      settle(null);
      /* Shopify.onError reads a description out of the response body, which a dropped
         connection does not have - and it is not worth an uncaught error on top of a
         failed removal. The row coming back is the signal in that case. */
      try { Shopify.onError(xhr, status); } catch(e){}
    });
  };

  /***** The cart's one way to change how many of a line there are *****

    +, -, and typing a number into the box all come through Shopify.scSetQuantity.
    One path on purpose: they are the same operation with different gestures, and two
    systems moving the same money is how this goes subtly wrong.

    Three things it fixes at once.

    Typing did nothing at all. The box is name="updates[]" inside the cart's
    <form action="/cart" method="post">, so a typed 33 was never dead - it was live
    but invisible: the page went on showing 1 and a subtotal for 1, and the 33 was
    applied at checkout. Worse, measured on this form: the only submit button in it
    is <button type="submit" name="checkout">, so pressing Enter in the quantity box
    submitted the form WITH that button's name and went straight to checkout carrying
    the typed figure. Enter is intercepted below for that reason.

    + and - each waited a whole /cart/change.js round trip - about 600ms of Shopify's
    own server time, the same latency the removal path measured and could not fix - so
    five clicks up was five sequential round trips. Now the figures move at once and
    the request is debounced, so a burst sends one call carrying the final number.

    And the displayed number could lie. A refusal at the cap left whatever was in the
    box sitting there; now every path ends with the box agreeing with the cart.

    How it keeps the money honest, following the removal path above:

      - every figure is painted from a baseline captured once at the start of a burst,
        never by repeatedly scaling what is already on screen, so ten clicks cannot
        accumulate rounding drift;
      - the baseline is the undo. A failed request puts back the number AND the
        figures, which is the whole of the owner's complaint;
      - a line already at its cap sends nothing (see Shopify.scCapFor), and a burst
        that nets back to where it started sends nothing either;
      - only the last call in flight is allowed to redraw, and while a change is
        pending updateQuickCart and scSyncCartRows are told to leave these rows alone,
        because Bold fires updateQuickCart with a pre-change snapshot about 100ms
        after a click and that snapshot would otherwise put the old number back - the
        same 4->3->4->3 flicker the removal branch measured.

    The Bold trap, which the removal path hit first: a Bold parent's data-line-price
    is the whole visible row, parent plus its hidden option children. Scaling that
    figure by newQty/oldQty is therefore the right arithmetic for the row the shopper
    can see, and is what happens here - the same number removal subtracts.
  *****/

  Shopify.scQtyPending = {};

  /* Long enough to swallow a burst - clicks land 70-150ms apart - and short enough
     that one deliberate click still commits before a shopper looks away. Below the
     ~600ms the round trip costs anyway, so a single change is no slower than it was. */
  Shopify.SC_QTY_DEBOUNCE = 350;

  Shopify.scQtyIsPending = function(key){
    return !!(key && Object.prototype.hasOwnProperty.call(Shopify.scQtyPending, key));
  };
  Shopify.scQtyBusy = function(){
    for(var k in Shopify.scQtyPending){
      if(Object.prototype.hasOwnProperty.call(Shopify.scQtyPending, k)){ return true; }
    }
    return false;
  };

  /* Every quantity box for one line - the cart page's and the header drawer's copy of
     the same row - so they never disagree. Matched on the attribute because a line key
     carries a colon, which starts a pseudo-class in a selector. */
  Shopify.scQtyBoxes = function(key){
    var out = [], all = document.querySelectorAll('input.txtbox[data-id]'), i;
    for(i = 0; i < all.length; i++){
      if(all[i].getAttribute('data-id') === key){ out.push(all[i]); }
    }
    return out;
  };

  /* The cart page's <ul> for a line, which is where the money lives. Null on a page
     that has no cart table - a product page, say - and then the figures are simply
     left to the response. */
  Shopify.scCartRowFor = function(key){
    var container = document.querySelector('.cart_tbl .con_row');
    if(!container){ return null; }
    var boxes = container.querySelectorAll('.txtbox'), i;
    for(i = 0; i < boxes.length; i++){
      if(boxes[i].getAttribute('data-id') !== key){ continue; }
      var row = boxes[i];
      while(row && row.parentNode !== container){ row = row.parentNode; }
      return (row && row.tagName === 'UL') ? row : null;
    }
    return null;
  };

  /* Everything this burst may have to put back, read before anything is touched.
     Scoping of the subtotal elements follows Shopify.scOptimisticRemove exactly: the
     drawer's copy comes first in the document, and writing it is also what wakes the
     sticky bar's MutationObserver in conv-cust-js.js - which is what re-counts the
     "(n items)" beside the subtotal from the boxes on screen. */
  Shopify.scQtySnapshot = function(key, baseQty){
    var row = Shopify.scCartRowFor(key);
    var totalEl = document.querySelector('.cart_tbl span.total-price');
    var drawerTotals = document.querySelectorAll('div.cart_menu span.total-price');
    var rowTotalEl = row && row.children[4] ? row.children[4].querySelector('.price') : null;
    // '.count' is selectors.TOTAL_ITEMS, which lives inside the ready() scope below.
    var headerEls = jQuery('.count');

    var snap = {
      key: key,
      baseQty: baseQty,
      row: row,
      rowTotalEl: rowTotalEl,
      totalEl: totalEl,
      drawerTotals: drawerTotals,
      headerEls: headerEls,
      baseRowCents: row ? parseInt(row.getAttribute('data-line-price'), 10) : NaN,
      baseTotalCents: totalEl ? parseInt(totalEl.getAttribute('data-cart-total'), 10) : NaN,
      baseRowTotalHtml: rowTotalEl ? rowTotalEl.innerHTML : null,
      baseTotalHtml: totalEl ? totalEl.innerHTML : null,
      baseDrawerHtml: [].map.call(drawerTotals, function(el){ return el.innerHTML; }),
      baseHeader: headerEls.length ? headerEls.first().text() : null,
      baseHeaderHidden: headerEls.length ? headerEls.first().hasClass('hidden') : false
    };
    snap.canDoMoney = !!(row && totalEl && rowTotalEl && baseQty > 0 &&
                         !isNaN(snap.baseRowCents) && !isNaN(snap.baseTotalCents) &&
                         window.Shopify && typeof Shopify.formatMoney === 'function' &&
                         window.app && app.data && app.data.money_format);
    return snap;
  };

  // Sum of every visible line's box, which is what the header badge counts.
  function unitsOnScreen(){
    var container = document.querySelector('.cart_tbl .con_row');
    if(!container){ return null; }
    var boxes = container.querySelectorAll('.txtbox'), n = 0, i;
    for(i = 0; i < boxes.length; i++){ n += parseInt(boxes[i].value, 10) || 0; }
    return n;
  }

  /* Show the cart as it would be at `qty`. Always computed from the snapshot's
     baseline, never from what is on screen, so a burst cannot drift. */
  Shopify.scQtyPaint = function(snap, qty){
    var boxes = Shopify.scQtyBoxes(snap.key), i;
    for(i = 0; i < boxes.length; i++){
      boxes[i].value = qty;
      boxes[i].setAttribute('data-sc-last', qty);
    }
    if(snap.canDoMoney){
      var rowCents = Math.round(snap.baseRowCents * qty / snap.baseQty);
      var totalCents = Math.max(0, snap.baseTotalCents + (rowCents - snap.baseRowCents));
      snap.row.setAttribute('data-line-price', String(rowCents));
      snap.rowTotalEl.innerHTML = Shopify.formatMoney(rowCents, app.data.money_format);
      var money = Shopify.formatMoney(totalCents, app.data.money_format);
      snap.totalEl.setAttribute('data-cart-total', String(totalCents));
      snap.totalEl.innerHTML = money;
      for(var d = 0; d < snap.drawerTotals.length; d++){ snap.drawerTotals[d].innerHTML = money; }
    }
    var units = unitsOnScreen();
    if(snap.headerEls.length && units !== null){
      if(units > 0){ snap.headerEls.text(String(units)).removeClass('hidden'); }
      else { snap.headerEls.text('').addClass('hidden'); }
    }
  };

  // The call did not happen: put the number and every figure back.
  Shopify.scQtyRestore = function(snap){
    var boxes = Shopify.scQtyBoxes(snap.key), i;
    for(i = 0; i < boxes.length; i++){
      boxes[i].value = snap.baseQty;
      boxes[i].setAttribute('data-sc-last', snap.baseQty);
    }
    if(snap.canDoMoney){
      snap.row.setAttribute('data-line-price', String(snap.baseRowCents));
      snap.rowTotalEl.innerHTML = snap.baseRowTotalHtml;
      snap.totalEl.setAttribute('data-cart-total', String(snap.baseTotalCents));
      snap.totalEl.innerHTML = snap.baseTotalHtml;
    }
    for(var d = 0; d < snap.drawerTotals.length; d++){
      snap.drawerTotals[d].innerHTML = snap.baseDrawerHtml[d];
    }
    if(snap.headerEls.length && snap.baseHeader !== null){
      if(snap.baseHeaderHidden){ snap.headerEls.text(snap.baseHeader).addClass('hidden'); }
      else { snap.headerEls.text(snap.baseHeader).removeClass('hidden'); }
    }
  };

  /***** Typing a quantity *****

    'change', not 'input'. 'input' fires per keystroke, so typing 12 would ask for 1
    on the way to 12; 'change' fires once the shopper has finished - on blur, and on
    Enter.

    Enter needs intercepting. Measured on this form: the box is name="updates[]"
    inside <form action="/cart" method="post">, and the only submit button in it is
    <button type="submit" name="checkout">. Implicit submission therefore posted the
    typed quantity together with that button's name and sent the shopper to checkout.
    preventDefault stops that and blurs instead, which raises the same 'change' every
    other route uses. Nothing is rebound and no attribute is changed, so a browser
    with JS off still posts updates[] natively and Shopify still applies and caps it.

    focusin records what the box said before editing, which is what garbage gets put
    back to.
  *****/
  jQuery(document).on('focusin', '.cart_tbl .txtbox, .cart_menu .txtbox', function(){
    var v = parseInt(jQuery(this).val(), 10);
    if(!isNaN(v)){ this.setAttribute('data-sc-last', v); }
  });

  jQuery(document).on('keydown', '.cart_tbl .txtbox, .cart_menu .txtbox', function(e){
    if(e.which !== 13 && e.key !== 'Enter'){ return; }
    e.preventDefault();
    /* Apply it here rather than leaning on blur to raise 'change'. A field only
       fires 'change' on blur if the user dirtied it, so anything that sets .value
       programmatically - another script, an autofill - would blur silently and leave
       the box showing a number the cart never heard about. Asking directly is the
       same call 'change' would have made, and a 'change' arriving afterwards carries
       the same figure and is absorbed by the debounce. */
    var id = jQuery(this).data('id');
    if(id){ Shopify.scSetQuantity(id, jQuery(this).val()); }
    this.blur();
  });

  jQuery(document).on('change', '.cart_tbl .txtbox, .cart_menu .txtbox', function(){
    var id = jQuery(this).data('id');
    if(id){ Shopify.scSetQuantity(id, jQuery(this).val()); }
  });

  /* One step up or down, from whichever + or - was pressed. It steps from the box's
     last agreed value rather than whatever text is sitting in it, so a half-typed or
     stale figure cannot be turned into a request. */
  Shopify.scStepQuantity = function(btn, delta){
    var inputEl = jQuery(btn).parent().find("input");
    var id = inputEl.data("id");
    var from = parseInt(inputEl.attr('data-sc-last'), 10);
    if(isNaN(from)){ from = parseInt(inputEl.val(), 10); }
    if(isNaN(from)){ from = 0; }
    Shopify.scSetQuantity(id, from + delta);
  };

  /**
   * Shopify.scSetQuantity
   *
   * @param key    - the line item key
   * @param wanted - the quantity asked for, however it was asked for
   */
  Shopify.scSetQuantity = function(key, wanted){
    if(!key){ return; }

    var state = Shopify.scQtyPending[key];
    var boxes = Shopify.scQtyBoxes(key);
    if(!boxes.length){ return; }

    /* Garbage - letters, a negative, a decimal, an empty box. Put back what was there
       and send nothing. Whole numbers only, tested as text: parseInt would happily
       read "2.7" as 2 and "3kg" as 3, and quietly charging someone for a number they
       did not type is worse than refusing to guess. */
    var n;
    if(typeof wanted === 'number'){
      n = wanted;
      if(!isFinite(n) || Math.floor(n) !== n){ n = NaN; }
    }else{
      var raw = String(wanted).replace(/^\s+|\s+$/g, '');
      n = /^\d+$/.test(raw) ? parseInt(raw, 10) : NaN;
    }
    if(isNaN(n) || n < 0){
      var known = state ? state.snap.baseQty : parseInt(boxes[0].getAttribute('data-sc-last'), 10);
      if(isNaN(known)){ known = parseInt(boxes[0].defaultValue, 10); }
      if(!isNaN(known)){ for(var g = 0; g < boxes.length; g++){ boxes[g].value = known; } }
      return;
    }

    /* Zero is a removal, which is what - already does when it steps off the last one,
       so typing 0 and clicking - down to 0 agree. Removal has its own optimistic path
       and its own reconciliation; this one does not try to do both jobs. */
    if(n === 0){
      if(state){ window.clearTimeout(state.timer); delete Shopify.scQtyPending[key]; }
      Shopify.scRemoveLine(key);
      return;
    }

    /* The ceiling, from the map rendered in theme.liquid - no request needed to learn
       a refusal we can predict. Clamping here is also what corrects a box left showing
       something impossible, which is the owner's "it will give me an error but still
       not change the number". */
    var cap = (typeof Shopify.scCapFor === 'function') ? Shopify.scCapFor(key) : null;
    var clamped = false;
    if(cap !== null && n > cap){ n = cap; clamped = true; }
    if(n < 1){ n = 1; }

    // First change of a burst: this is what a failure rolls back to.
    if(!state){
      var baseQty = parseInt(boxes[0].getAttribute('data-sc-last'), 10);
      if(isNaN(baseQty)){ baseQty = parseInt(boxes[0].value, 10); }
      if(isNaN(baseQty) || baseQty < 1){ baseQty = 1; }
      state = Shopify.scQtyPending[key] = {
        snap: Shopify.scQtySnapshot(key, baseQty),
        timer: null,
        target: baseQty
      };
    }

    if(clamped && typeof Shopify.scRefuseLocally === 'function'){
      Shopify.scRefuseLocally(key, cap);
    }
    /* Remembered for the flush: a burst that climbed into the cap still ends in a
       successful change, and success clears the band (see the onCartUpdate wrapper).
       The shopper was refused, so the band has to come back afterwards - otherwise
       the evidence of the refusal vanishes half a second after they saw it. */
    if(clamped){ state.clampedTo = cap; }

    state.target = n;
    Shopify.scQtyPaint(state.snap, n);

    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function(){ Shopify.scFlushQuantity(key); }, Shopify.SC_QTY_DEBOUNCE);
  };

  /* Send the burst's final number, once.
   *
   * Overlapping calls settle the way removals do: only the last one still in flight
   * redraws, and once two have overlapped it reconciles from a fresh /cart.js rather
   * than from a snapshot that may predate the other call.
   */
  Shopify.scFlushQuantity = function(key){
    var state = Shopify.scQtyPending[key];
    if(!state){ return; }
    window.clearTimeout(state.timer);

    var snap = state.snap, target = state.target;

    // Netted back to where it started - nothing to tell Shopify.
    if(target === snap.baseQty){
      delete Shopify.scQtyPending[key];
      return;
    }

    Shopify.scQtyInFlight = (Shopify.scQtyInFlight || 0) + 1;
    if(Shopify.scQtyInFlight > 1){ Shopify.scQtyOverlapped = true; }

    var settle = function(cart){
      Shopify.scQtyInFlight = Math.max(0, (Shopify.scQtyInFlight || 1) - 1);
      if(Shopify.scQtyInFlight > 0){ return; }      /* a later call will redraw */
      if(Shopify.scQtyOverlapped){
        Shopify.scQtyOverlapped = false;
        jQuery.getJSON('/cart.js', function(fresh){ Shopify.updateQuickCart(fresh); })
              .fail(function(){ if(cart){ Shopify.updateQuickCart(cart); } });
        return;
      }
      if(cart){ Shopify.updateQuickCart(cart); }
    };

    /* changeItem has no error callback of its own; api.jquery.js routes failures to
       Shopify.onError, which already knows which line this was from the intent pinned
       to the request. Set the undo up before the call, never after it. */
    state.rollback = function(){
      delete Shopify.scQtyPending[key];
      Shopify.scQtyRestore(snap);
      settle(null);
    };

    var clampedTo = state.clampedTo;

    Shopify.changeItem(key, target, function(cart){
      /* Cleared BEFORE the redraw, or updateQuickCart and scSyncCartRows would leave
         these rows alone - which is right while a change is pending and wrong now
         that the server has answered. */
      delete Shopify.scQtyPending[key];
      settle(cart);
      /* The burst ran into the ceiling on its way here. settle() has just redrawn
         from a successful response, which clears the band; put it back, because the
         refusal that produced it really did happen and is still true. */
      if(clampedTo != null && typeof Shopify.scRefuseLocally === 'function'){
        Shopify.scShownSignature = null;
        Shopify.scRefuseLocally(key, clampedTo);
      }
    });
  };

  /* Called by Shopify.onError when a cart call for a known row fails, so a quantity
     change that did not happen does not leave the number or the money claiming it did. */
  Shopify.scQtyRollback = function(key){
    var state = key && Shopify.scQtyPending[key];
    if(state && typeof state.rollback === 'function'){ state.rollback(); return true; }
    return false;
  };

  /**
   * Shopify.scSyncCartRows
   *
   * The cart page's rows used to be replaced wholesale on every update, which threw
   * away whatever other scripts had put inside them - Bold's "Edit Item" button, and
   * Clyde's protection-plan widget, which injects once per page load and so was simply
   * gone until the shopper reloaded. Reconcile by line key instead: a line that is
   * still in the cart keeps its own <ul> and only has its figures rewritten, a line
   * that has left is removed, and a new line is inserted where it belongs without
   * disturbing its neighbours. Rows carrying a Clyde band keep the .sc-cart-clyde
   * spacer that follows them (see conv-cust-js.js).
   *
   * Moving a row would reload any iframe inside it, so a row is only ever touched when
   * it is genuinely out of position.
   *
   * @param container - the .con_row element, or undefined off the cart page
   * @param rows      - [{key, price, total, quantity}] in cart order
   * @param html      - the rendered <ul> for each of those rows, same order
   * @return true when the rows were reconciled, false to fall back to a full replace
   */
  Shopify.scSyncCartRows = function(container, rows, html){
    if(!container || !container.children){ return false; }

    var present = [], byKey = {}, known = 0, i;
    for(i = 0; i < container.children.length; i++){ present.push(container.children[i]); }
    for(i = 0; i < present.length; i++){
      if(present[i].tagName !== 'UL'){ continue; }
      var input = present[i].querySelector('.txtbox');
      var key = input && input.getAttribute('data-id');
      if(!key){ return false; }   /* markup we do not recognise - let the caller replace */
      byKey[key] = present[i];
      known++;
    }
    if(!known){ return false; }   /* first render: nothing to preserve */

    var spacerAfter = function(node){
      var next = node.nextElementSibling;
      return (next && next.className.indexOf('sc-cart-clyde') > -1) ? next : null;
    };

    var prev = null;
    for(i = 0; i < rows.length; i++){
      var ul = byKey[rows[i].key];
      if(ul){
        delete byKey[rows[i].key];
        var price = ul.children[2] && ul.children[2].querySelector('.price');
        var total = ul.children[4] && ul.children[4].querySelector('.price');
        var box = ul.querySelector('.txtbox');
        /* A quantity change still pending on this line owns these figures until it
           settles. Bold fires updateQuickCart with a pre-change snapshot about 100ms
           after a click, and writing that here is exactly how the removal branch got
           its measured 4->3->4->3 flicker - the same snapshot would put the old
           number back under the shopper's finger. The settle path clears the pending
           entry before it redraws, so the authoritative cart still lands. */
        var qtyHeld = Shopify.scQtyIsPending && Shopify.scQtyIsPending(rows[i].key);
        if(price){ price.innerHTML = rows[i].price; }
        if(!qtyHeld){
          if(total){ total.innerHTML = rows[i].total; }
          if(box && String(box.value) !== String(rows[i].quantity)){ box.value = rows[i].quantity; }
          if(box){ box.setAttribute('data-sc-last', rows[i].quantity); }
          /* The cents behind the figure, for Shopify.scOptimisticRemove. A quantity
             change moves it, so it is rewritten here and not only at build time. */
          if(rows[i].lineCents != null){ ul.setAttribute('data-line-price', rows[i].lineCents); }
        }
        if(rows[i].boldParent){ ul.setAttribute('data-bold-parent', '1'); }
        else { ul.removeAttribute('data-bold-parent'); }
      }else{
        var holder = document.createElement('div');
        holder.innerHTML = html[i];
        ul = holder.firstElementChild;
        if(!ul){ continue; }
      }
      var after = prev ? (spacerAfter(prev) || prev) : null;
      if(ul.parentNode !== container || ul.previousElementSibling !== after){
        container.insertBefore(ul, after ? after.nextSibling : container.firstChild);
      }
      prev = ul;
    }

    for(var gone in byKey){
      if(!byKey.hasOwnProperty(gone)){ continue; }
      var dead = byKey[gone], tail = spacerAfter(dead);
      if(tail){ tail.parentNode.removeChild(tail); }
      dead.parentNode.removeChild(dead);
    }
    return true;
  };

  
  Shopify.updateQuickCart = function(cart, boldCart = false){

    /* A cart update that is not ours, arriving while a removal is still in flight,
       carries a snapshot from before that removal - Bold fires one off its own cart
       load, within ~100ms of the click on a cold page - and scSyncCartRows honours it
       faithfully, putting the row we just took out back on screen until the response
       finally lands. Measured as a 4->3->4->3 flicker on the first removal after a
       cold load. The removal's own settle() redraws when it has the real cart, and it
       decrements the counter before calling in here, so this never blocks that. */
    if(Shopify.scRemovalsInFlight > 0){ return; }

    ///BOLD Install: fix the cart
    if(typeof window.BOLD !== 'undefined'
       && typeof window.BOLD.common !== 'undefined'
       && typeof window.BOLD.common.cartDoctor !== 'undefined') {
      // NOTE: "cart" should be the variable containing the cart json data
      cart = window.BOLD.common.cartDoctor.fix(cart);
    }

    
//     if(typeof BOLD === 'object' && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
//       cart = BOLD.common.cartDoctor.fix(cart);
//     }

    var t = jQ(selectors.QUICK_CART_MENU),
        c = jQ(selectors.CART_PAGE_MENU);
    if(t.length){

      if(cart.items.length){

        var toAppend = [],
            rowData = [],
            tableHeader = '<ul><li>Photo</li>'+
        '<li>Name</li>'+
        '<li>Price</li>'+
        '<li>Quantity</li>'+
        '<li>Total</li></ul>';

        for (var i = 0; i < cart.items.length; i++) {
          var row = "";

          var itemPrice = cart.items[i].price,
              totalPrice = cart.total_price,
              linePrice = cart.items[i].line_price,
              title = cart.items[i].variant_title,
              cartNote = cart.note;

          if(title == null){
            title = "";
          }
          if(cartNote == null){
            cartNote = "";
          }

          //convert prices
          var itemPriceConverted = Shopify.formatMoney(itemPrice,app.data.money_format),
              totalPriceConverted = Shopify.formatMoney(totalPrice,app.data.money_format),
              linePriceConverted = Shopify.formatMoney(linePrice,app.data.money_format);                  
          
          

           /* A Bold parent is a line with option children hiding behind it; the row
              is marked so a removal knows not to pre-empt Bold's own tidying up. */
           var rowProps = cart.items[i].properties || {};
           var rowIsBoldParent = !!(rowProps._boldBuilderId && rowProps._boldVariantIds != null);
           row += '<ul data-line-price="' + linePrice + '"' + (rowIsBoldParent ? ' data-bold-parent="1"' : '') + '><li><div class="thumb"><a href="' + cart.items[i].url + 
              '"><img src="' + Shopify.addImageSize(cart.items[i].image,'small') + '" alt="' + cart.items[i].title + 
              '"></a></div></li><li><h5><a href="' + cart.items[i].url + 
              '" class="item-name">' + cart.items[i].product_title + (cart.items[i].properties_formatted || '' ) +
              '</a></h5><p class="product-type">'+title+'</p><div class="sc-cart-actions"><div class="bold_edit_in_cart"></div></div></li>'+
              '<li><p class="mobile-label-price">Price</p><span class="money price">'+itemPriceConverted+'</span></li>'+
              '<li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox" min="0" id="updates_'+cart.items[i].key+'" data-id="'+cart.items[i].key+'" value="'+cart.items[i].quantity+'" /><a class="plus_btn"></a>'+
              
              '<div class="ajaxcart__errors text-center ajaxcart__item__'+cart.items[i].key+'__errors">All available stock is in cart</div></li>'+    
              '<li><p class="mobile-label-total">Total</p><span class="money price">'+ linePriceConverted +'</span>'+
              '<a href="#" data-id="'+cart.items[i].key+'" class="remove_item_button sc-remove" title="Remove" aria-label="Remove"><span class="fa fa-times" aria-hidden="true"></span></a>'+
              '</li></ul>';
          toAppend.push(row);
          rowData.push({
            key: cart.items[i].key,
            price: itemPriceConverted,
            total: linePriceConverted,
            quantity: cart.items[i].quantity,
            lineCents: linePrice,
            boldParent: rowIsBoldParent
          });
          row = "";
        };

        var checkoutRow = t.find('div.checkout_row'),
            subtotalRow = t.find('span.total-price'),
            subtotalRowCartPage = c.find("span.total-price");
        if(checkoutRow.length){ /* we have existing items in the quick cart */
          t.find('div.cart_row').html(toAppend.join(''));
          t.find('div.cart_row').prepend(tableHeader);
          if(!Shopify.scSyncCartRows(c.find(".con_row")[0], rowData, toAppend)){
            c.find(".con_row").html(toAppend.join(''));
          }
          /* data-cart-total is what Shopify.scOptimisticRemove does its arithmetic on,
             so it has to be rewritten with the figure beside it - unless a quantity
             change is still pending, in which case this snapshot may predate it and
             the subtotal on screen is the newer truth. Shopify.scFlushQuantity clears
             the pending entry before it redraws, so the real figure always lands. */
          if(!(Shopify.scQtyBusy && Shopify.scQtyBusy())){
            subtotalRowCartPage.attr('data-cart-total', cart.total_price).html(totalPriceConverted);
            subtotalRow.html(totalPriceConverted);
          }
        }else{
          checkoutRow = '<div class="checkout_row clearfix"><button type="submit" name="checkout" value="Check Out" class="btn_c">Check Out</button> <a href="javascript:void(0)" class="info_btn"><span class="fa fa-chevron-left"></span>Continue Shopping</a></div>';
          subtotalRow = '<div class="total_row clearfix"><ul><li><span class="total_val">Subtotal:</span><span class="money total-price">'+totalPriceConverted+'</span></li></ul></div>';
          var addCheckOutBlock = '<div id="additional-checkout-block" class="text-right" ></div>';
          var form = jQ('<form />',{
            'action':'/cart',
            'method':'post',
            'novalidate':'novalidate'
          })
              
              if(true){
                var notesRow='<div class="clearfix order_notes">'+
                    '<label for="cartSpecialInstructions" class="sr-only">Order Notes:</label>'+
                    '<textarea name="note" id="cartSpecialInstructionsFromPopup" class="note_text" placeholder="Order Notes">'+ cartNote +'</textarea></div>';
              }
          else{
            var notesRow='';
          }
          form.append($("div.cart_row"));
          form.find("div.cart_row").html(toAppend.join(''));
          form.find('div.cart_row').prepend(tableHeader);
          form.append(subtotalRow);
          form.append(notesRow);
          
          form.append(checkoutRow);
          form.append(addCheckOutBlock);
          t.append(form);
   
        }

      }
      else{
        t.html('<div class="menu_title clearfix"><h4>Shopping Cart</h4> </div><div class="cart_row"><div class="empty-cart">Your cart is currently empty.</div><p><a href="javascript:void(0)" class="btn_c btn_close">Continue Shopping</a></p></div>'); 
        /* Only if it is not already there. Replacing .cart_tbl wholesale tears down
           everything inside it - the summary card, the sticky bar, and the PayPal,
           Google Pay and Shop Pay iframes, which then re-handshake. Doing that a
           second time, ~700ms after the optimistic empty state already rendered the
           same thing, is the visible jolt and none of it is needed. */
        if(!c.find('.empty-cart-message').length){ c.html(Shopify.scEmptyCartHtml()); }
       }  
      } 
        if(!$(selectors.CART_PAGE_MENU).length){
          setTimeout(function(){    
            if(!boldCart)
            {
              Shopify.showModal($(selectors.QUICK_CART_MENU).wrap('<p>').parent().html());
            }
          }, 500);
        }
        
        if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
            typeof BOLD.common.eventEmitter.emit === 'function'){
          $('[name=checkout].bold_hidden').removeAttr('style').removeClass('bold_hidden');      
          $('[name=checkout].bold_clone').remove();
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
        }
        
        Shopify.scClydeCartGuard(cart, $(selectors.CART_PAGE_MENU).length > 0);

        Shopify.onCartUpdate(cart);         
      
      };
      
      $.getJSON("/cart.js", function(cart){
        Shopify.updateQuickCart(cart, true);
      });

      
      /**
 * This updates the N item/items left in your cart
 * 
 * It's setup to match the HTML used to display the Cart Count on Load. If you change that (in your theme.liquid) 
 * you will probably want to change the message html here. 
 * This will update the HTML in ANY element with the class defined in selectors.TOTAL_ITEMS
 *
 * @param object the cart object. 
 * @param HTMLElement form. If included, we know its an Update of the CART FORM, which will trigger additional behaviour. 
 */
      Shopify.onCartUpdate = function(cart, form) {
        if(typeof window.BOLD !== 'undefined'
           && typeof window.BOLD.common !== 'undefined'
           && typeof window.BOLD.common.cartDoctor !== 'undefined') {
          // NOTE: "cart" should be the variable containing the cart json data
          cart = window.BOLD.common.cartDoctor.fix(cart);
        }
        // Total Items Update - the count the shopper can see, not cart.item_count,
        // which counts Bold's hidden option lines too. See Shopify.scVisibleItemCount.
        var message = Shopify.scVisibleItemCount(cart);
        if(message > 0){
          jQ(selectors.TOTAL_ITEMS).text(message).removeClass('hidden');
        }else{
          jQ(selectors.TOTAL_ITEMS).text('').addClass('hidden');
        }
      };

      /***** Cart errors, inline instead of in a modal *****

        Shopify.onError is the single funnel for every cart-API failure. All nine
        call sites in api.jquery.js arrive here: addItem (171), addItemFromForm
        (201), getCartShippingRatesForDestination (240), changeItem (278),
        removeItem (302), clear (328), updateCartFromForm (358),
        updateCartAttributes (402) and updateCartNote (426). api.jquery.js:56 also
        defines an alert()-based onError, but that is only its default - this file
        loads after it and overwrites the property, so the alert never runs.

        The failure the owner reported is a 422 on availability. Verified live
        against Coyote Red Glaze (variant 43929382453495, 1 on hand, inventory
        policy DENY):

          POST /cart/add.js    id=...&quantity=3                     -> 422
          POST /cart/change.js id=...&quantity=5                     -> 422
            {"status":422,
             "message":"Only 1 item was added to your cart due to availability.",
             "description":"Only 1 item was added to your cart due to availability."}

          POST /cart/add.js    id=...&quantity=1, one already in cart -> 422
            {"status":422,
             "message":"The maximum quantity of this item is already in your cart.",
             "description":"The maximum quantity of this item is already in your cart."}

        So message and description carry the same sentence in both of the real
        bodies and either would read correctly today. description is preferred
        because the older shape api.jquery.js documents at line 58 put the generic
        "Cart Error" in message and the useful sentence in description; message is
        the fallback for the reverse. Shopify's wording is passed through as-is.

        Where the message goes is decided by what the shopper just touched, which is
        what the wrappers at the bottom of this block record:

          a quantity control or a remove names a line item -> that row's own
            .ajaxcart__errors slot, already rendered under every quantity control by
            templates/cart.liquid, snippets/menu-cart.liquid and the quick-cart
            rebuild further up this file;
          an add from the product form has no row yet -> above the Add to Cart
            button, in the same panel the Bold required-option refusal uses in
            conv-cust-js.js, so the two kinds of refusal read as one system;
          a cart update names a whole form and no one row -> the top of that cart
            table, where the shopper is already looking after pressing Update.

        Anything else keeps the modal: a shipping-rate, cart-note or cart-attribute
        failure, a cart/clear, or a call made by an app rather than by this theme.
        That is the line. None of those has a row or a button of its own to belong
        to, and an error with no home still has to be impossible to miss - going
        quiet would be worse than being ugly.
      *****/

      /* What the pending cart call is about.

         This is a handover slot, not storage: the wrappers below put an intent in
         it immediately before calling into api.jquery.js, and the ajaxPrefilter
         further down takes it straight back out and pins it to that request's own
         jqXHR, inside the same synchronous call stack. Nothing is meant to still be
         sitting here by the time any response comes back.

         It used to be read by onError instead, and that was the spam-click bug the
         owner hit. Six clicks on a maxed-out row fire six /cart/change.js calls
         before the first reply lands; one slot cannot describe six requests. The
         first 422 consumed it and drew the band, and 422s two to six found it empty,
         fell through to the no-context branch - which clears whatever is on screen
         first - and reopened the modal. Measured, not guessed: instrumenting
         onError over a six-click burst showed intent present on call 1 and null on
         calls 2 through 6, ending with zero bands and one modal.

         The TTL only covers the case where a wrapped call never reaches jQuery.ajax
         at all, so the slot is never collected. */
      Shopify.scCartIntent = null;
      Shopify.SC_INTENT_TTL = 15000;

      // Every inline message now on screen, so a later success can take them all
      // back down whichever context they went into.
      Shopify.scShownErrors = [];

      /* What is on screen right now, as context + message. A burst of identical
         refusals should redraw nothing and announce once; without this, calls 2..n
         tear the band out of the DOM and put an identical one back, and queue a
         fresh live-region announcement each time. */
      Shopify.scShownSignature = null;

      Shopify.scTrim = function(value) {
        return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
      };

      /* Pin the pending intent to the request that is being built, so the answer
         carries its own context home.

         A prefilter runs synchronously inside jQuery.ajax, which the wrappers call
         synchronously, so the intent sitting in the slot here is this request's and
         no other. jQuery hands the same jqXHR to the error callback, and
         api.jquery.js passes that straight to Shopify.onError as its first
         argument - so by the time we read it back, context and response have
         travelled together and any number of calls can be in flight at once.

         The slot is emptied on the way past. This prefilter sees every jQuery
         request on the page, including other people's, so leaving a used intent
         lying around is how an unrelated failure would end up wearing it. */
      jQuery.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        if (Shopify.scCartIntent) {
          jqXHR.scIntent = Shopify.scCartIntent;
          Shopify.scCartIntent = null;
        }
      });

      /* Shopify's sentence for this failure, or '' if the response carried none.

         Deliberately tolerant. The old code called jQuery.parseJSON straight on
         responseText, which throws on an empty body or on an HTML error page and
         took the whole handler down with it - so a 500, a timeout or a dropped
         connection showed the shopper nothing at all. */
      Shopify.scErrorMessage = function(XMLHttpRequest) {
        var raw = (XMLHttpRequest && XMLHttpRequest.responseText) || '';
        var data = null;
        try { data = JSON.parse(raw); } catch (e) { data = null; }
        if (!data || typeof data !== 'object') { return ''; }

        var description = Shopify.scTrim(data.description);
        if (description) { return description; }
        var message = Shopify.scTrim(data.message);
        if (message) { return message; }

        // The attribute-hash shape api.jquery.js's own helper is written for.
        if (typeof Shopify.fullMessagesFromErrors === 'function') {
          try {
            var full = Shopify.scTrim(Shopify.fullMessagesFromErrors(data).join('; '));
            if (full) { return full; }
          } catch (e2) {}
        }
        return '';
      };

      /***** Our words for the one refusal we can recognise *****

        Shopify's sentence for running out of stock is written from the warehouse's
        point of view - "Only 3 items were added to your cart due to availability."
        reports on a transaction, and does not say the thing a potter buying glaze
        actually wants to know, which is how many there are.

        This is the only case we take over, because it is the only one we can both
        recognise reliably and phrase better. Everything else that reaches
        Shopify.onError - a shipping-rate rejection, a cart-note failure, a 500 -
        keeps Shopify's own words, because we cannot anticipate what they will say
        and a wrong paraphrase is worse than a clumsy accurate one.

        Register is borrowed from the product page, which has had a line for exactly
        this situation all along: sections/product.liquid renders
        .maximum-in-stock-error with products.product.maximum_quantity_error,
        "Maximum quantity available reached.", shown by the quantity stepper in
        scripts.js.liquid when the shopper tries to step past stock. Short, factual,
        no exclamation, no scolding for having clicked. A shopper can meet both in
        one session, so the cart should not suddenly change voice. What the cart
        adds is the number, which is what the owner asked for and what the product
        line does not give.

        And when we cannot work out a number, the fallback is that same sentence,
        read from the same locale key - one string, one voice, no invented
        placeholder and no wrong figure.
      *****/
      Shopify.SC_MAX_QTY_TEXT = "Maximum quantity available reached.";

      /* Is this the out-of-stock refusal? Matched on Shopify's own phrasings:

           "Only 1 item was added to your cart due to availability."
           "Only 3 items were added to your cart due to availability."
           "The maximum quantity of this item is already in your cart."

         The first two are what /cart/add.js and /cart/change.js return when they cap
         a line; the third is what /cart/add.js returns when the line is already at
         the cap. All three verified live against Speedball and Coyote glazes with
         inventory policy DENY. The looser two tests are there for the neighbouring
         wordings Shopify uses elsewhere for the same situation. */
      Shopify.scIsAvailabilityError = function(message) {
        return /due to availability/i.test(message)
            || /maximum quantity/i.test(message)
            || /already in your cart/i.test(message)
            || /left in stock/i.test(message);
      };

      /* How many the shopper can actually have, without asking the network.

         Shopify usually says it outright - the number in "Only 3 items were added"
         IS the stock figure, because that is what it capped the line to.

         Where it does not ("The maximum quantity of this item is already in your
         cart"), the row knows. A refused change leaves the line at the most the
         shopper can have, and the quantity box still shows it: the cart's + handler
         only writes the box on success, so after a refusal it still reads the last
         figure Shopify accepted, which is the cap. That is why this needs no fetch.

         Returns null rather than a guess when neither source can answer. */
      Shopify.scAvailableCount = function(message, intent) {
        var named = /\bonly\s+(\d+)\b/i.exec(message || '');
        if (named) {
          var n = parseInt(named[1], 10);
          if (!isNaN(n) && n > 0) { return n; }
        }
        if (intent && intent.kind === 'row' && intent.key) {
          return Shopify.scRowQuantity(intent.key);
        }
        return null;
      };

      // The quantity box for one line item. Compared by attribute rather than by
      // selector for the same reason as the error slots: a line item key carries a
      // colon, which starts a pseudo-class in a selector.
      Shopify.scRowQuantity = function(key) {
        var inputs = document.querySelectorAll('input.txtbox[data-id]');
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].getAttribute('data-id') !== key) { continue; }
          var q = parseInt(inputs[i].value, 10);
          if (!isNaN(q) && q > 0) { return q; }
        }
        return null;
      };

      /* The sentence itself, given a count or null. Shared, because the same words
         have to come out whether the refusal was Shopify's over the wire or ours
         before we sent anything - a shopper clicking + should not be able to tell
         which of the two answered. */
      Shopify.scStockSentence = function(n) {
        if (n === null) { return Shopify.SC_MAX_QTY_TEXT; }
        if (n === 1) { return 'Only 1 in stock, and it is already in your cart.'; }
        return 'Only ' + n + ' in stock, and they are already in your cart.';
      };

      // Our sentence, or null to leave Shopify's alone.
      Shopify.scAvailabilityCopy = function(message, intent) {
        if (!Shopify.scIsAvailabilityError(message)) { return null; }
        return Shopify.scStockSentence(Shopify.scAvailableCount(message, intent));
      };

      /***** Refusing without asking *****

        The cap for a line, from the map layout/theme.liquid rendered, or null when
        this line has none - stock not counted, policy set to continue, or a line
        that joined the cart after the page did and so was never in the map. Null
        means behave exactly as before: send the change and let Shopify answer.
      *****/
      Shopify.scCapFor = function(key) {
        var caps = Shopify.scCapByKey;
        if (!caps || !key || !Object.prototype.hasOwnProperty.call(caps, key)) { return null; }
        var cap = parseInt(caps[key], 10);
        return isNaN(cap) ? null : cap;
      };

      /* Would asking for this many be refused? Returns the cap if so, else null.

         Answered from the number already in the page, so a shopper leaning on + at
         the cap sends nothing at all - which is the point: seven clicks used to mean
         seven /cart/change.js calls and a Cloudflare block waiting at the end of a
         long enough burst. */
      Shopify.scWouldExceedStock = function(key, wanted) {
        var cap = Shopify.scCapFor(key);
        if (cap === null || wanted <= cap) { return null; }
        return cap;
      };

      /* Say so, in the row, without having asked anyone.

         Same words, same slot and same announcement as a 422 would have produced -
         and the same signature guard, so holding + down redraws nothing and
         announces once. */
      Shopify.scRefuseLocally = function(key, cap) {
        var message = Shopify.scStockSentence(cap);
        var signature = 'row|' + key + '|' + message;
        if (signature === Shopify.scShownSignature) { return; }
        Shopify.scClearCartError();
        var placed = Shopify.scShowRowError(key, message);
        Shopify.scShownSignature = signature;
        if (placed) {
          Shopify.scAnnounce(message);
        } else {
          // The click came from a row, so this should not happen; if the row is
          // somehow not laid out, be seen anyway rather than swallow the refusal.
          Shopify.scShowModalError(message);
        }
      };

      /* The error slots belonging to one line item.

         Matched by walking .ajaxcart__errors and comparing class lists rather than
         by building a selector out of the key. Line item keys look like
         43929382453495:5b6c9f3a... - to a CSS selector that colon starts a
         pseudo-class, and the escaping the two older call sites in this file attempt
         is broken anyway (they compute escapedId and then interpolate the unescaped
         escapeId), so no selector built from a raw key can be trusted.

         Plural because one row can be on the page twice: the cart page and the
         header quick cart each render a slot for the same key. */
      Shopify.scErrorSlots = function(key) {
        var out = [];
        if (!key) { return out; }
        var wanted = ' ajaxcart__item__' + key + '__errors ';
        var nodes = document.querySelectorAll('.ajaxcart__errors');
        for (var i = 0; i < nodes.length; i++) {
          if ((' ' + nodes[i].className + ' ').indexOf(wanted) >= 0) { out.push(nodes[i]); }
        }
        return out;
      };

      /* Announcement.

         Taking the modal away also took away the focus move that used to make the
         message unmissable to a screen reader, so the text is additionally written
         into one polite live region that lives for the life of the page. It has to
         be a region that was already in the accessibility tree when its text
         changed, which a slot sitting at display:none until the moment it is needed
         is not.

         Emptied and then rewritten a tick later so that pressing the same refused
         control twice announces twice - an unchanged live region is not re-read. */
      Shopify.scAnnounce = function(message) {
        var region = document.getElementById('sc-cart-error-live');
        if (!region) {
          region = document.createElement('div');
          region.id = 'sc-cart-error-live';
          region.className = 'visually-hidden';
          region.setAttribute('role', 'status');
          region.setAttribute('aria-live', 'polite');
          region.setAttribute('aria-atomic', 'true');
          document.body.appendChild(region);
        }
        region.textContent = '';
        window.setTimeout(function() { region.textContent = message || ''; }, 60);
      };

      // Put every inline message away and leave the DOM as it was found.
      Shopify.scClearCartError = function() {
        // Forget what was showing, so the same refusal drawn again after a success
        // is treated as new rather than skipped as a repeat.
        Shopify.scShownSignature = null;
        while (Shopify.scShownErrors.length) {
          var shown = Shopify.scShownErrors.pop();
          var el = shown.el;
          if (!el || !el.parentNode) { continue; }
          if (shown.remove) {
            el.parentNode.removeChild(el);
          } else {
            // A reused row slot: hand back the markup's own placeholder text, the
            // display it had before and the cell it was lifted out of, so the
            // pre-existing .show().delay().fadeOut() paths in this file still find
            // it where they expect and behave exactly as they did.
            el.className = shown.className;
            el.textContent = shown.text;
            el.style.display = shown.display;
            if (shown.parent) {
              if (shown.before && shown.before.parentNode === shown.parent) {
                shown.parent.insertBefore(el, shown.before);
              } else {
                shown.parent.appendChild(el);
              }
            }
          }
        }
        var region = document.getElementById('sc-cart-error-live');
        if (region) { region.textContent = ''; }
      };

      /* The message in the failing row's own slot. Returns whether it found one.

         A slot only counts if its row is actually laid out. The cart page and the
         closed quick-cart drawer can both carry a slot for the same key, and showing
         the message into the shut drawer would put it where nobody can read it. The
         slot is display:none until now, so what gets measured is the cell around it.

         The slot is then lifted out of the quantity cell and dropped in just below
         its own row. It has to move: the slot was built for one short hardcoded line
         ("All available stock is in cart") and lives in a cell that is 20% of the
         table on desktop and 34% of it under 480px - about 115px either way, which
         turns a Shopify sentence into a four-line sliver pressed against the Total
         column. Measured on the cart page, a row is its own display:table and
         .con_row around it is a plain block, so a block placed between two rows is
         simply full width - 735px at 1440, 325px at 390 - with no table-cell to
         escape and nothing to measure. Flush under the row it belongs to, with the
         gap below it, so it reads as that row's and not the next one's.

         scClearCartError puts it back in the cell it came from. */
      Shopify.scShowRowError = function(key, message) {
        var slots = Shopify.scErrorSlots(key);
        var placed = false;
        for (var i = 0; i < slots.length; i++) {
          var el = slots[i];
          var cell = el.parentNode;
          if (!cell || !cell.getClientRects().length) { continue; }
          var row = el.closest ? el.closest('ul') : null;
          Shopify.scShownErrors.push({
            el: el,
            className: el.className,
            text: el.textContent,
            display: el.style.display,
            parent: cell,
            before: el.nextSibling,
            remove: false
          });
          // text-center comes off for the duration. The slot is centred for the one
          // short hardcoded line it was built for ("All available stock is in cart");
          // a wrapped sentence in a narrow column reads badly centred. It is set
          // !important in style.css, so the class goes rather than being out-shouted,
          // and the saved className above puts it back.
          el.className = el.className.replace(/(^|\s)text-center(?=\s|$)/g, '') + ' sc-cart-error';
          el.textContent = message;
          el.style.display = 'block';
          if (row && row.parentNode) { row.parentNode.insertBefore(el, row.nextSibling); }
          placed = true;
        }
        return placed;
      };

      Shopify.scErrorPanel = function(message) {
        var note = document.createElement('p');
        note.className = 'sc-cart-error-note';
        note.textContent = message;
        return note;
      };

      /* The message above the Add to Cart button, for an add that has no row yet.

         Same home and same panel as the Bold required-option message in
         conv-cust-js.js: first child of the .desc_blk_bot row holding the button.
         The shopper just pressed that button, so it is on screen by definition and
         the page does not have to move for the message to be read. First child
         rather than beside the button because that row is a float layout - .price
         left, #addToCart right - and a block dropped between them has its lines
         shortened by the price and reads as a caption hanging off it. */
      Shopify.scShowProductError = function(form, message) {
        var scope = form || document;
        var buttons = scope.querySelectorAll ? scope.querySelectorAll('#addToCart') : [];
        var button = null;
        for (var i = 0; i < buttons.length; i++) {
          // Bold hides the theme's #addToCart and injects a clone carrying the same
          // id, so there are usually two. The laid-out one is the visible one.
          if (buttons[i].getBoundingClientRect().width > 10) { button = buttons[i]; break; }
        }
        if (!button) { button = buttons[0] || null; }
        if (!button) { return false; }

        var note = Shopify.scErrorPanel(message);
        var row = button.closest ? button.closest('.desc_blk_bot') : null;
        if (row) {
          row.insertBefore(note, row.firstChild);
        } else if (button.parentNode) {
          button.parentNode.insertBefore(note, button);
        } else {
          return false;
        }
        Shopify.scShownErrors.push({ el: note, remove: true });
        return true;
      };

      /* The message at the top of the cart table, for an update that named a whole
         form rather than one row. Above the rows, not below them: after pressing
         Update the shopper is looking at the table, and a cart long enough to scroll
         would hide a message parked at the bottom. */
      Shopify.scShowCartError = function(form, message) {
        var scope = jQuery(form || '.cart_tbl');
        var rows = scope.find('.con_row').filter(':visible').first();
        var note = Shopify.scErrorPanel(message);
        if (rows.length) {
          rows.before(note);
        } else if (scope.filter(':visible').length) {
          scope.filter(':visible').first().prepend(note);
        } else {
          return false;
        }
        Shopify.scShownErrors.push({ el: note, remove: true });
        return true;
      };

      // The old modal, kept for the failures that have nowhere better to go.
      Shopify.scShowModalError = function(message) {
        if (typeof $().magnificPopup !== 'function') {
          alert(message);
          return;
        }
        $.magnificPopup.open({
          items: {
            src: '<div class="mfp-with-anim modal-popup error"><h3>Error</h3>' + message + '</div>',
            type: 'inline'
          },
          mainClass: 'mfp-move-from-top',
          removalDelay: 1000
        });
      };

      Shopify.onError = function(XMLHttpRequest, textStatus) {
        /* This request's own context, carried back on its jqXHR by the prefilter.
           Every concurrent call has its own, which is what makes a burst of clicks
           behave like one click repeated rather than one click and then five
           strangers. The slot is only consulted as a fallback, for a failure raised
           by something that never went through jQuery.ajax. */
        var intent = (XMLHttpRequest && XMLHttpRequest.scIntent) || null;
        if (!intent) {
          intent = Shopify.scCartIntent;
          Shopify.scCartIntent = null;
          if (intent && (new Date().getTime() - intent.at) > Shopify.SC_INTENT_TTL) {
            intent = null;
          }
        }

        /* A quantity change that did not happen must not leave the number or the
           money claiming it did - that lying figure is the whole of the complaint
           this path exists to fix. Rolled back before the message is drawn, so the
           band lands on a row that already reads correctly. */
        if (intent && intent.kind === 'row' && typeof Shopify.scQtyRollback === 'function') {
          try { Shopify.scQtyRollback(intent.key); } catch (e) {}
        }

        var message = Shopify.scErrorMessage(XMLHttpRequest);
        if (!message) {
          // No body, or a body with no sentence in it: an HTML error page, a
          // timeout, an aborted request. There is nothing of Shopify's to quote, so
          // say the one thing that is certainly true rather than show an empty panel.
          message = 'Your cart could not be updated. Please try again.';
        }

        // The one case we say better than Shopify does; everything else keeps its
        // own words. Done before placing, so whichever home it lands in - and the
        // modal too - speaks with one voice.
        var ours = Shopify.scAvailabilityCopy(message, intent);
        if (ours) { message = ours; }

        /* Same refusal, same place, already on screen: leave it alone. Six clicks
           on a maxed-out row produce six identical 422s, and redrawing the band for
           each would churn the DOM and queue six announcements for a message that
           never changed. */
        var signature = (intent ? intent.kind + '|' + (intent.key || '') : 'none') + '|' + message;
        if (signature === Shopify.scShownSignature) { return; }

        // Never stack two messages for one shopper action.
        Shopify.scClearCartError();

        var placed = false;
        if (intent && intent.kind === 'row') {
          placed = Shopify.scShowRowError(intent.key, message);
        } else if (intent && intent.kind === 'add') {
          placed = Shopify.scShowProductError(intent.form, message);
        } else if (intent && intent.kind === 'cart') {
          placed = Shopify.scShowCartError(intent.form, message);
        }

        if (placed) {
          Shopify.scShownSignature = signature;
          Shopify.scAnnounce(message);
        } else {
          Shopify.scShownSignature = null;
          Shopify.scShowModalError(message);
        }
      };

      /* Recording which row, button or form a cart call is about, and clearing the
         message once a later call succeeds.

         Wrapping the api.jquery.js entry points by name, in one place, rather than
         tagging the thirty-odd call sites in this file: nothing for a new call site
         to forget, and api.jquery.js itself is left alone. The five entry points not
         wrapped - getCartShippingRatesForDestination, clear, updateCartAttributes,
         updateCartNote and getCart - have no row and no button to belong to, so they
         keep the modal.

         changeItem and removeItem are called by this theme's quantity and remove
         controls with a line item key, which is what the slots are keyed by. Called
         instead with a bare variant id or a line number, which api.jquery.js also
         allows, the key matches no slot and the error falls back to the modal. */
      (function() {
        var wrapped = {
          addItem:            { at: 2, intent: function(a) { return { kind: 'add',  form: null }; } },
          addItemFromForm:    { at: 1, intent: function(a) { return { kind: 'add',  form: a[0] || null }; } },
          changeItem:         { at: 2, intent: function(a) { return { kind: 'row',  key: a[0] }; } },
          removeItem:         { at: 1, intent: function(a) { return { kind: 'row',  key: a[0] }; } },
          updateCartFromForm: { at: 1, intent: function(a) { return { kind: 'cart', form: a[0] || null }; } }
        };

        jQuery.each(wrapped, function(name, spec) {
          var original = Shopify[name];
          if (typeof original !== 'function') { return; }
          Shopify[name] = function() {
            var args = Array.prototype.slice.call(arguments);
            var intent = spec.intent(args);
            intent.at = new Date().getTime();
            Shopify.scCartIntent = intent;

            /* Only ever decorate a callback that was already there. Every one of
               these success handlers in api.jquery.js reads
               `if (typeof callback === 'function')` and otherwise runs a default of
               its own - onItemAdded, onCartUpdate, getCart(updateQuickCart). Putting
               a function where there was none would silently switch that default
               off, so when no callback was passed the clearing is left to the
               onCartUpdate and onItemAdded wrappers below, which those defaults
               run through. */
            var callback = args[spec.at];
            if (typeof callback === 'function') {
              args[spec.at] = function() {
                Shopify.scCartIntent = null;
                Shopify.scClearCartError();
                return callback.apply(this, arguments);
              };
            }
            return original.apply(Shopify, args);
          };
        });

        // Got through: the condition the message described is resolved, so the
        // message goes rather than sitting there stale.
        jQuery.each(['onCartUpdate', 'onItemAdded'], function(i, name) {
          var original = Shopify[name];
          if (typeof original !== 'function') { return; }
          Shopify[name] = function() {
            Shopify.scCartIntent = null;
            Shopify.scClearCartError();
            return original.apply(Shopify, arguments);
          };
        });
      })();
      
      $(".cart_tbl").on("focusout","textarea", function(){
        var note = $(this).val(),
            textareas = jQ(selectors.QUICK_CART_MENU).find("textarea");

        Shopify.updateCartNote(note);
      });

      jQuery(".cart_tbl").on("click",".plus_btn", function () {
        Shopify.scStepQuantity(this, +1);
      })

      jQuery(".cart_tbl").on("click", ".minus_btn", function () {
        /* Stepping the last one off a line is still a removal - scSetQuantity sends
           0 down the removal path, so - at 1 behaves exactly as it did. */
        Shopify.scStepQuantity(this, -1);
      });

      $(".cart_tbl").on("click",".remove_item_button", function(e){
        e.preventDefault();

        var el = $(this),
            id = el.data('id') || null;
        if(!id){ return; }

        /* The row leaves now rather than in ~600ms - see Shopify.scOptimisticRemove. */
        Shopify.scRemoveLine(id);
      });
      /// End  Changes for cart page  ///

      //End Wrapper    
    });